import { Header, Page } from 'redesign';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { WorkflowCreateForm, WorkflowCreateToolbox } from './workflow-create-toolbox';
import { WorkflowEditor } from '../../components/workflow-editor/workflow-editor';
import { useWorkflowGraph } from '../../components/workflow-editor/graph/hooks/use-workflow-graph';
import { useWorkflowCreateSubmit } from '../../hooks/use-workflow-create-submit';

export const WorkflowCreate = () => {
  const { t } = useTranslation(['web-common', 'ogp-screen-specific']);
  const graphControl = useWorkflowGraph();
  const isGraphValid = graphControl.isGraphValidForCreate();

  const form = useForm<WorkflowCreateForm>({
    defaultValues: { workflowName: '' },
  });

  const { onSubmit, mutation } = useWorkflowCreateSubmit({
    mapNodesToDto: graphControl.mapNodesToDto,
  });

  return (
    <FormProvider {...form}>
      <Page
        header={<Header titleText={t('workflows.create.title', { ns: 'ogp-screen-specific' })} />}
        toolbox={
          <WorkflowCreateToolbox
            onCreateClick={form.handleSubmit(onSubmit)}
            mutationStatus={mutation.status}
            disabled={!isGraphValid || mutation.isLoading}
          />
        }
      >
        <WorkflowEditor graphControl={graphControl} />
      </Page>
    </FormProvider>
  );
};
